(function () {
  'use strict';
  var defs = '<filter id="ctcFlowerCutout" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 -20 0 18.5"/><feComposite in2="SourceGraphic" operator="in"/></filter>' +
    '<radialGradient id="ctcPear" cx=".3" cy=".25" r=".8"><stop stop-color="#b8a45c"/><stop offset=".55" stop-color="#8c8644"/><stop offset="1" stop-color="#484c29"/></radialGradient>' +
    '<radialGradient id="ctcPomegranate" cx=".3" cy=".2" r=".8"><stop stop-color="#b16958"/><stop offset=".5" stop-color="#813e39"/><stop offset="1" stop-color="#462729"/></radialGradient>' +
    '<linearGradient id="ctcSceneWax"><stop stop-color="#b9ae98"/><stop offset=".24" stop-color="#f8efda"/><stop offset=".65" stop-color="#e9dcc1"/><stop offset="1" stop-color="#c7b799"/></linearGradient>' +
    '<linearGradient id="ctcSceneMetal" x1="0" x2="1" y2=".7"><stop stop-color="#dcd3bc"/><stop offset=".25" stop-color="#8b8070"/><stop offset=".48" stop-color="#f8f2df"/><stop offset=".63" stop-color="#b9afa0"/><stop offset="1" stop-color="#625b52"/></linearGradient>' +
    '<filter id="ctcFruitGrain"><feTurbulence baseFrequency=".24" numOctaves="2" seed="14" result="noise"/><feComposite in="noise" in2="SourceGraphic" operator="in"/><feBlend in2="SourceGraphic" mode="soft-light"/></filter>';

  function escapeAttr(s) { return String(s).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  function pear(x, y, r) {
    return '<g transform="translate(' + x + ' ' + y + ') rotate(' + r + ')">' +
      '<ellipse cy="32" rx="35" ry="13" fill="#191712" opacity=".22"/>' +
      '<path d="M -8 -43 C -22 -42 -15 -23 -30 -3 C -58 39 30 53 33 13 C 34 -5 11 -16 10 -37 Q 10 -47 -8 -43Z" fill="url(#ctcPear)" filter="url(#ctcFruitGrain)"/>' +
      '<path d="M0 -42 Q -8 -53 2 -61" stroke="#62503b" stroke-width="4" fill="none"/>' +
      '<path d="M2 -47 Q31 -69 40 -57 Q24 -38 2 -47Z" fill="#515538"/>' +
      '<path d="M-19 3 Q-27 16 -17 25" fill="none" stroke="#d4bd77" stroke-width="2" opacity=".4"/></g>';
  }

  function fruit(diameter) {
    var k = Math.min(1.25, diameter / 330);
    return '<g data-ctc-still-life="fruit" aria-hidden="true" transform="translate(0 -12) scale(' + k + ')">' +
      pear(-62, -8, -25) + pear(44, -28, 25) + pear(0, 30, 64) +
      '<g transform="translate(91 25)"><ellipse cy="29" rx="34" ry="12" fill="#191712" opacity=".25"/><circle r="35" fill="url(#ctcPomegranate)" filter="url(#ctcFruitGrain)"/><path d="M-7 -31 L-9 -44 L-2 -39 L3 -45 L7 -34Z" fill="#694437"/><path d="M-21 -13 Q-29 2 -19 8" fill="none" stroke="#d2917b" opacity=".35" stroke-width="2"/></g></g>';
  }

  function wax(width, height, base) {
    return '<g aria-hidden="true" transform="translate(0 ' + base + ')">' +
      '<ellipse cy="' + (-height) + '" rx="90" ry="100" fill="url(#ctcFlameGlow)"/>' +
      '<rect x="' + (-width/2) + '" y="' + (-height) + '" width="' + width + '" height="' + height + '" rx="3" fill="url(#ctcSceneWax)"/>' +
      '<ellipse cy="' + (-height) + '" rx="' + (width/2) + '" ry="3" fill="#f8edcf"/>' +
      '<path d="M0 ' + (-height) + ' l1 -6" stroke="#443326" stroke-width="1.5"/>' +
      '<path d="M1 ' + (-height-5) + ' C-9 ' + (-height-10) + ' -2 ' + (-height-24) + ' 2 ' + (-height-27) + ' C1 ' + (-height-16) + ' 10 ' + (-height-9) + ' 1 ' + (-height-5) + 'Z" fill="#ffdb9b"/>' +
      '<ellipse cx="1" cy="' + (-height-11) + '" rx="2" ry="6" fill="#fff9df"/></g>';
  }

  function center(p, decor, flowerAsset, tilt, piece) {
    var h = p.d2 || (p.iw && p.ih ? p.d * p.ih / p.iw : p.d);
    var upright = ['vase','candle','candlejar','carafe','cake'].indexOf(p.shape) >= 0;
    var out = piece;
    if (decor !== 'none') {
      if (p.shape === 'candle') {
        var wide = p.id === 'couronne-candle-holder';
        out = wax(wide ? 38 : 23, wide ? 115 : 210, -h*.26) + piece;
      }
      if (decor === 'winter' && p.shape === 'oval') out += fruit(p.d);
      if (decor === 'winter' && p.shape === 'vase' && flowerAsset) {
        var w = Math.min(340, p.d * 4.2), fh = w * .625;
        out += '<image data-ctc-still-life="flowers" aria-hidden="true" href="' + escapeAttr(flowerAsset) + '" x="' + (-w/2) + '" y="' + (-h/2-fh*.84) + '" width="' + w + '" height="' + fh + '" filter="url(#ctcFlowerCutout)"/>';
      }
    }
    return upright ? '<g transform="scale(1 ' + (1/tilt) + ')">' + out + '</g>' : out;
  }

  function accents(lay, decor) {
    if (decor !== 'winter') return '';
    var span = lay.kind === 'round' ? Math.min(350, lay.Rt*.3) : Math.min(750, lay.L*.3);
    var out = '<g data-ctc-still-life="accents" aria-hidden="true" pointer-events="none">';
    [-1,1].forEach(function (side) {
      var x = span * side;
      out += '<g transform="translate(' + x + ' 190) rotate(' + (side*13) + ')"><path d="M-65 0 Q0 -8 65 9" fill="none" stroke="#736a48" stroke-width="2"/>';
      [-42,-12,20,48].forEach(function (a,i) {
        var b = i%2 ? 1 : -1;
        out += '<path d="M' + a + ' 0 Q' + (a-25) + ' ' + (b*30) + ' ' + (a+8) + ' ' + (b*40) + ' Q' + (a+18) + ' ' + (b*18) + ' ' + a + ' 0Z" fill="' + (i%2 ? '#5e6445' : '#7c8061') + '"/>';
      });
      out += '</g>';
    });
    [-85,175].forEach(function (x,i) {
      out += '<g transform="translate(' + x + ' ' + (175+i*32) + ') rotate(' + (i*34-18) + ')"><ellipse cy="7" rx="26" ry="12" fill="#17130f" opacity=".18"/><path d="M0 -27 L7 -7 L28 -5 L12 8 L17 27 L0 16 L-18 27 L-12 7 L-28 -6 L-7 -8Z" fill="url(#ctcSceneMetal)" stroke="#c9bfa9" stroke-width=".8"/><path d="M0 -27 L0 16 L28 -5 L-12 7 L17 27 L-7 -8" fill="none" stroke="#fff9eb" opacity=".4" stroke-width="1"/></g>';
    });
    return out + '</g>';
  }

  function position(lay, index) {
    var points = lay.kind === 'round'
      ? [[-140,40],[-330,-110],[170,175],[300,-110]]
      : [[-130,0],[-570,45],[235,70],[540,-30]];
    return {x:points[index % points.length][0], y:points[index % points.length][1]};
  }

  window.CarronTableScene = { defs: defs, center: center, accents: accents, position: position };
})();
